import React, { useEffect } from 'react';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

export const Modal: React.FC<ModalProps> = ({ 
  isOpen, 
  onClose, 
  title, 
  children, 
  footer,
  size = 'md' 
}) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const sizeClasses = {
    sm: 'max-w-md',
    md: 'max-w-2xl',
    lg: 'max-w-4xl',
    xl: 'max-w-6xl',
  };

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-[9999] backdrop-blur-md animate-fade-in p-4"
      onClick={onClose}
    >
      <div 
        className={`bg-white rounded-3xl shadow-2xl ${sizeClasses[size]} w-full max-h-[90vh] overflow-hidden animate-slide-up border-2 border-green-100`}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex items-center justify-between p-6 bg-gradient-to-r from-green-600 to-green-700 text-white rounded-t-3xl">
          <h2 className="text-2xl font-bold flex items-center space-x-3">
            <span className="text-3xl">✨</span>
            <span>{title}</span>
          </h2>
          <button
            onClick={onClose}
            className="text-white hover:text-red-200 text-4xl leading-none transition-all duration-200 hover:rotate-90 hover:scale-110 transform bg-white bg-opacity-20 hover:bg-opacity-30 rounded-full w-10 h-10 flex items-center justify-center"
            title="Fermer"
          >
            &times;
          </button>
        </div>

        {/* Body */}
        <div className="p-8 overflow-y-auto max-h-[calc(90vh-180px)] bg-gray-50">
          {children}
        </div>

        {/* Footer */}
        {footer && (
          <div className="flex justify-end gap-4 p-6 border-t-2 border-gray-200 bg-gradient-to-r from-gray-50 to-white rounded-b-3xl">
            {footer}
          </div>
        )}
      </div>
    </div>
  );
};
